import React from 'react';
import { TableHead, TableRow, TableCell } from '@mui/material';

interface MailBoxesTableHeadProps {
  rcTranslate: (key: string) => string;
}

const MailBoxesTableHead: React.FC<MailBoxesTableHeadProps> = ({
  rcTranslate,
}) => (
  <TableHead>
    <TableRow>
      <TableCell>
        {rcTranslate('sites.closetWithSiteDetails.mailBoxes.positionHeader')}
      </TableCell>
      <TableCell>
        {rcTranslate('sites.closetWithSiteDetails.mailBoxes.numberHeader')}
      </TableCell>
      <TableCell />
    </TableRow>
  </TableHead>
);

export default MailBoxesTableHead;
